import React, {useState, useEffect, useRef} from 'react'
import {Link, useParams} from 'react-router-dom'

import './CompanyAccounts.scss'

import FlatBtn from '../../common/FlatBtn'
import {ImgInput} from '../../common/ImgInput'
import {useTranslation} from 'react-i18next'
import config from '../../../config'
import useApi from '../../../lib/hooks/useAPI'
import ActionButton from '../../common/ActionButton'
import QRCode from 'react-qr-code'
import {ReactComponent as CopyImg} from '../../common/img/COPY.svg'
import { ImgButtonII } from '../../common/ImgButton'
import {getTransactions} from '../../../Services/Utils/getTransactions'
import useNotify from '../../../lib/hooks/Notify';
import uuid from 'react-uuid'
let getTxMethodName = "api/v1/company.getTipTransactions" // "api/v1/company.getBillTransactions"

export const CompanyInvoice = () => {
  const [transactions, setTransactions] = useState([])
  
  const notify = useNotify();
  const api = useApi()
  const [data,setData] = useState({
    table: '',
    orderId: '',
    amount: '',
  })
  const linkRef = useRef(null)
  const [generated, setGenerated] = useState(null)
  const {companyId} = useParams()
  const {t} = useTranslation()
  
  const [user, setUser] = useState(null)
  const [company, setCompany] = useState(null)
  
  const generateUrl = (table, orderId, amount) => {
    let url = config.payUrl + '/tips/' + company.externalId + '?u=' + user.number + '&c=' + company.number
    if (table) url += '&t=' + table
    if (orderId) url += '&o=' + orderId
    if (amount) url += '&s=' + amount
    return url
  }

   const getUser = async () => {
    const res = await api.get('api/v1/user.get')
    if (!res.success || !res.data.users)  return
    setUser(res.data.users[0])
  }

  useEffect(() => {
    if (!generated) return
    if (transactions.length === 0) return
    if (!data.orderId) return
    const idx = transactions.findIndex(({orderNumber}) =>   orderNumber=== data.orderId)
    if (idx === -1) return
    if (transactions[idx].status !== 2) return
    setData({
      table: '',
      orderId: '',
      amount: ''
    })                                                                                                                                                                                          
    setGenerated(null)
    localStorage.removeItem("@invoice"+companyId)
    notify({ title: t('thingPaid'), type:'success', onClose: () => {
      linkRef.current.click()
    } });
    setTimeout(() => {
      linkRef.current.click()
    }, 2000)

  },[transactions, data])
  
  useEffect(() => {
    let timer 
    if (!generated || !companyId) return
    timer = setInterval(() => {
      getTransactions(
        api,
        getTxMethodName, {companyId, p: 0, l: 100,},
        () => {},
        (v) => v,
        setTransactions,
        () => {}
      )
    }, 2000)
    return () => {
      timer && clearInterval(timer)
    }
  },[companyId,generated])

  


  const getCompany = async () => {
    if (!companyId)  return
    const res = await api.get('api/v1/company.get', {companyId: companyId})
    if (!res.success || !res.data.companies) return
    setCompany(res.data.companies[0])
  }
  
  useEffect(() => {
      getUser()
  }, [])

  useEffect(() => {
    getCompany(companyId)
    const stored = localStorage.getItem("@invoice"+companyId)
    if (!stored) return 
    const {table, orderId, amount, generated} = JSON.parse(stored)
    setData({table,orderId,amount})
    setGenerated(generated)
  }, [companyId])

  const handleGenerate = () => {
    let id = data.orderId
    if (!id) {
      id = uuid()
      setData((prev) => ({...prev, orderId: id}))
    }
    setGenerated(generateUrl(data.table, id, data.amount))
    localStorage.setItem("@invoice"+companyId, JSON.stringify({
      table: data.table,
      orderId: id,
      amount: data.amount,
      generated: generateUrl(data.table, id, data.amount)
    }))
  }

  const handleGenerateNew = () => {
    setGenerated(null)
    setData({
      table: '',
      orderId: '',
      amount: ''
    })
    localStorage.removeItem("@invoice"+companyId)
  }

  return (<div className="admin central noselect">
    <div className="app-container admin__app-container">
      <div className="admin__header">
        <Link ref={linkRef} to={'/company/' + companyId}>
          <FlatBtn type="prev"/>
        </Link>
        <p className="header-text">
          {`${t('companyInvoice')}`}
        </p>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', gap:'20px', marginTop: '20px'}}>
        <ImgInput                  
          placeholder={t("table")}
          type="text"
          autoComplete="off"
          field={data.table}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '')
            setData({
              ...data,
              table: e.target.value
            })
          }}
                    readOnly={generated}
        />
        <ImgInput
          placeholder={t("orderId")}
          type="text"
          field={data.orderId}
          autoComplete="off"
          onChange={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '')
            setData({
              ...data,
              orderId: e.target.value
            })
          }}
          readOnly={generated}
        />
        <ImgInput
          readOnly={generated}
          placeholder={t("amount")}
          type="text"
          autoComplete="off"
          field={data.amount}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '')
            setData({
              ...data,
              amount: e.target.value
            })
          }}
        />
        {generated&&<div className="menu_qr">
              <QRCode value={generated} size={100}/>
        </div>}
        {generated&&<ImgButtonII image={<CopyImg/>}  text={t('copyURL')} onClick={() => {
          navigator.clipboard.writeText(generated)
        }} />}

        {!generated && <ActionButton text={t('generateThing')} onClick={handleGenerate} />}
        {generated && <ActionButton text={t('generateNew')} onClick={handleGenerateNew} />}
        
      </div>
    </div>
  </div>)
}
